<template>
  <div class="create-form">
    <div class="acivity-right">
      <el-form :inline="true" class="acivity-content-form" ref="formInline" :model="formInline" :rules="formrules" label-width="110px" style="width: 860px;">
        <el-form-item label="活动名称：" prop="title">
          <el-input v-model="formInline.title" placeholder="请输入活动名称" maxlength="50" class="inputwidth"></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" prop="date">
          <el-date-picker v-model="formInline.date" @change="dateChange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="列表缩略图：" prop="img">
          <el-upload class="avatar-uploader" style="width: 400px;" name="file_upload" :action="uploadURL" :show-file-list="false"
                     :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'img')}"
                     :before-upload="beforeAvatarUpload">
            <img v-if="formInline.img" :src="formInline.img" style="width: 178px; height: 120px; display: block;">
            <i v-else class="el-icon-plus avatar-uploader-icon" ></i>
          </el-upload>
          <p class="interface_update_p" style="width: 400px;">建议尺寸750px*205px，大小500kb以内，格式为jpg,png
          </p>
        </el-form-item>
        <el-form-item label="活动详情图：" >
          <el-upload class="avatar-uploader" style="width: 400px;" name="file_upload"
                     :action="uploadURL"
                     :show-file-list="false"
                     :on-success="(res, file) => { return handleInterfaceSuccess(res, file, 'bigimg')}"
                     :before-upload="beforeAvatarUpload">
            <img v-if="formInline.bigimg" :src="formInline.bigimg" style="width: 178px; height: 178px; display: block;">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p class="interface_update_p" style="width: 400px;">建议尺寸750px*750px，大小500kb以内，格式为jpg,png
          </p>
        </el-form-item>
        <el-form-item label="活动内容：" prop="content" style="height: 360px;">
          <!--<el-input type="textarea" style="width: 370px;" :autosize="{ minRows: 2, maxRows: 10}" placeholder="请输入活动内容" v-model="formInline.content" maxlength="40000">-->
          <!--</el-input>-->
          <editor v-model="formInline.content" class="picture-text-details" :action="uploadURL">
          </editor>
        </el-form-item>
        <el-form-item label="状态：">
          <el-radio-group v-model="formInline.status">
            <el-radio :label="0">禁用</el-radio>
            <el-radio :label="1">启用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="width:190px;margin: 0 0 20px 40%;" class="interface_btn">
        <el-button class="dialog-confirm-btn" style="margin-left: 10px" type="primary" @click="submitForm('formInline')">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { API_HOST, API_HOST_JAVA_SET } from '@/api/local'
import { editYxMarketing, getYxMarketingDetail } from '@/api/yunxiao.js'
import editor from '@/components/common/editor'
export default {
  name: 'add-marketing',
  data() {
    return {
      id: 0,
      formInline: {
        title: '',
        date: [],
        start: '',
        end: '',
        img: '',
        bigimg: '',
        content: '',
        status: 0
      },
      formrules: {
        title: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入活动内容', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请选择列表缩略图', trigger: 'blur' }
        ],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        }
      },
      pickerAppointedOptions: {
        disabledDate: (time) => {
          let _this = this
          let start = new Date(Date.parse(_this.formInline.start.replace(/-/g, '/')))
          let end = new Date(Date.parse(_this.formInline.end.replace(/-/g, '/')))
          return !((time.getTime() >= start) && (time.getTime() <= end))
        }
      },
    }
  },
  components: {
    editor,
  },
  computed: {
    uploadURL() {
      return API_HOST + '/admin/Upload/upload'
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editMarketing()
        } else {
          return false
        }
      })
    },
    editMarketing() {
      editYxMarketing(this.id,this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          router.push('/home/yxmarketing')
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    dateChange(value) {
      //console.log(value[0])
      if (value) {
        this.formInline.start = value[0]
        this.formInline.end = value[1]
      } else {
        this.formInline.start = ''
        this.formInline.end = ''
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 500 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        _g.toastMsg('error', '上传活动图片大小不能超过500KB!')
      }
      const check = (isJPG && isLt2M) || (isPNG && isLt2M)
      if (check) {
        _g.toastMsg('success', '正在上传')
      }
      return check
    },
    handleInterfaceSuccess(res, file, index) {
      if (res.code != 0) {
        _g.toastMsg('error', res.error)
      }
      if (index === 'img') {
        this.formInline.img = res.data.path
      }
      if (index === 'bigimg') {
        this.formInline.bigimg = res.data.path
      }
      _g.toastMsg('success', '上传成功')
    },
    getData(){
      getYxMarketingDetail(this.id).then(res => {
        this.formInline = JSON.parse(JSON.stringify(res.data.data))
        this.formInline.date = [this.formInline.start, this.formInline.end]
      })
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getData()
  },
}

</script>
<style scoped>
.create-form {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  width: calc(100% - 40px);
  background: #fff;
  margin: 20px auto 0;
  overflow-x: hidden;
}
.acivity-right {
  margin: 20px auto;
  width: 100%;
  align-items: center;
  display: block;
  justify-content: center;
}
.inputwidth{
  width: 370px;
}
.acivity-content-form {
  width: 534px;
  text-align: left;
  margin: auto;
}

.acivity-content-form .el-form-item__content {
  width: 300px;
}

.acivity-content-form p {
  margin: 0px;
  line-height: 20px;
  text-align: left;
  color: #999;
  font-size: 12px;
}
.x_input{
  width:172px!important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
</style>
